import React, { useEffect, useState } from 'react';
import './App.css';
import { AnimatePresence } from 'framer-motion';
import Dot from './components/Dot';
import Home from './pages/Home';
import Skills from './pages/Skills';
import Projects from './pages/Projects';
import { printLetterByLetter, hideIcons, hideSocialIcons, showIcons, showSocialIcons } from './functions.js';
import { Route, Routes, useLocation } from 'react-router-dom';

function App() {
	const [loadedOnce, setLoadedOnce] = useState(false);
	const location = useLocation();

	useEffect(async () => {
		// when the page loads
		const introWrapper = document.getElementsByClassName('intro-wrapper')[0];

		const headerText = document.getElementById('header-text');

		if (location.pathname == '/' && !loadedOnce) {
			hideIcons();
			hideSocialIcons();

			const languagesText = document.getElementById('languages');
			languagesText.innerHTML = '';

			const librariestooldText = document.getElementById('tools');
			librariestooldText.innerHTML = '';

			const skillsLink = document.getElementById('skills-link');
			skillsLink.className = 'hidden';

			const projectsLink = document.getElementById('projects-link');
			projectsLink.className = 'hidden';

			const cvLink = document.getElementById('cv-link');
			cvLink.className = 'hidden';

			try {
				await printLetterByLetter(headerText, headText, 100);
			} catch (e) {
				//
			}

			setTimeout(() => {
				try {
					headerText.style.transform = 'translateY(-800%)';
				} catch (e) {
					//
				}

				setTimeout(() => {
					try {
						headerText.style.opacity = 0;
						introWrapper.style.opacity = 1;

						headerText.parentNode.removeChild(headerText);
					} catch (e) {
						//
					}

					printLetterByLetter(languagesText, langText, 100).then(() => {
						showIcons(0, 10);
					});
					printLetterByLetter(librariestooldText, toolsText, 100).then(() => {
						showIcons(10, 20);
					});

					const titleText = document.getElementById('title-text');
					titleText.innerHTML = '';

					const contentText = document.getElementById('content-text');
					contentText.innerHTML = '';

					printLetterByLetter(document.getElementById('title-text'), helloText, 100);
					printLetterByLetter(document.getElementById('content-text'), contText, 50).then(() => {
						setTimeout(() => {
							skillsLink.style.opacity = 1;
						}, 100);
						setTimeout(() => {
							projectsLink.style.opacity = 1;
						}, 400);
						setTimeout(() => {
							cvLink.style.opacity = 1;
						}, 700);
						showSocialIcons();
					});
				}, 400);
			}, 700);

			setLoadedOnce(true);
		} else {
			if (headerText) headerText.parentNode.removeChild(headerText);
			if (introWrapper) introWrapper.style.opacity = 1;
		}
	}, []);

	return (
		<div className="App">
			<svg className="gradient-bg" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 800 800">
				<defs>
					<filter id="bbblurry-filter" x="-100%" y="-100%" width="400%" height="400%" filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
						<feGaussianBlur stdDeviation="93" x="0%" y="0%" width="100%" height="100%" in="SourceGraphic" edgeMode="none" result="blur"></feGaussianBlur>
					</filter>
				</defs>
				<g filter="url(#bbblurry-filter)">
					<ellipse rx="181" ry="147" cx="167.38875134526108" cy="105.98101528074172" fill="hsla(164, 63%, 47%, 1.00)"></ellipse>
					<ellipse rx="181" ry="147" cx="695.334228515625" cy="239.91551208496094" fill="hsla(190, 94%, 53%, 1.00)"></ellipse>
					<ellipse rx="181" ry="147" cx="368.8228853469974" cy="460.9335646988803" fill="hsla(0, 42%, 79%, 1.00)"></ellipse>
				</g>
			</svg>
			<header className="App-header">
				{' '}
				{/* eslint-disable-next-line */}
				<h1 id="header-text"></h1>
				<AnimatePresence>
					<div className="intro-wrapper hidden">
						<div className="nav-wrapper">
							<div className="dots-wrapper">
								<Dot color="#FC6058" />
								<Dot color="#FEC02F" />
								<Dot color="#2ACA3E" />
							</div>
						</div>
						<div className="content-wrapper">
							<Routes>
								<Route path="/" element={<Home pageVariants={pageVariants} pageTransition={pageTransition} helloText={helloText} contText={contText} langText={langText} toolsText={toolsText} />} />
								<Route path="/skills" element={<Skills pageVariants={pageVariants} pageTransition={pageTransition} />} />
								<Route path="/projects" element={<Projects pageVariants={pageVariants} pageTransition={pageTransition} />} />
							</Routes>
						</div>
					</div>
				</AnimatePresence>
			</header>
		</div>
	);
}

const headText = "Hi, I'm Nadhir.";
const helloText = 'Hello!';
const contText = "I'm a fullstack web developer.";
// const contText = "I make stuf bla bla bla idk i use a lot of things idk how to express myself haha lol sorry. Lorem ipsum that latin thing idk haha filler goes brrrrr";

const langText = 'Languages';
const toolsText = 'Libraries / Tools';

const pageVariants = {
	initial: { opacity: 0 },
	in: { opacity: 1 },
	out: { opacity: 0 },
};
const pageTransition = {
	type: 'fade',
	duration: 0.5,
};

export default App;
